// The cash calculator on the payment screen: what is left to pay, the change to give back, and the cash handed over that is sent
// with the payment so the server can print "Cash given / Change" on the paid bill.

const toNumber = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

const cents = (value) => Math.round(toNumber(value) * 100);

/**
 * @param {string|number} totalCash what the customer handed over (as typed)
 * @param {string|number} due       what is being paid now (the whole bill, or this part of a split)
 * @returns {{remaining: string|number, change: string|number, tendered: number}}
 *   remaining / change are shown as typed before (0 when nothing is left); tendered is a number of dollars (0 when nothing was entered)
 */
export function cashFigures(totalCash, due) {
  const tenderedCents = cents(totalCash);
  const dueCents = cents(due);
  const remainingCents = Math.max(0, dueCents - tenderedCents);
  const changeCents = Math.max(0, tenderedCents - dueCents);
  return {
    remaining: remainingCents > 0 ? (remainingCents / 100).toFixed(2) : 0,
    change: changeCents > 0 ? (changeCents / 100).toFixed(2) : 0,
    tendered: tenderedCents / 100,
  };
}

/**
 * The cash to send with a payment, or null when none should be sent: only cash payments, only when something was entered.
 * The server decides whether it covers the charge and works out the change itself.
 */
export function cashToSend({ isCash, paid, tendered }) {
  if (!isCash || !paid) return null;
  const n = toNumber(tendered);
  return n > 0 ? n : null;
}
